var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"masthead"}},[(_vm.is2lg)?_c('desktop-masthead'):_c('mobile-masthead'),_c('navigation-banner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }